import { render, staticRenderFns } from "./GenericReportTable.vue?vue&type=template&id=b9d1e950&"
import script from "./GenericReportTable.vue?vue&type=script&lang=js&"
export * from "./GenericReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports